module.exports = __webpack_public_path__ + "static/media/ding.4dd02c4e.mp3";